import { effect, inject, Injectable } from '@angular/core';
import { DeclinableProductStepperStore } from '../declinable-product-stepper.store';
import { StepperUtil } from '../util/stepper-util';
import { DeclinableProductBlockAutoNextStepService } from './declinable-product-block-auto-next-step.service';

@Injectable()
export class DeclinableProductAutoNextStepService {
  private readonly declinableProductStepperStore = inject(DeclinableProductStepperStore);
  private readonly declinableProductBlockAutoNextStepService = inject(
    DeclinableProductBlockAutoNextStepService,
  );

  constructor() {
    effect(
      () => {
        // go next step, if the step is valid and the user can not make more choices
        const blockAutoNextStep =
          this.declinableProductBlockAutoNextStepService.blockAutoNextStep();
        if (blockAutoNextStep) {
          return;
        }

        const steppers = this.declinableProductStepperStore.steppers();
        if (!steppers) {
          return;
        }
        const currentStepper =
          steppers.simpleProductStepper ?? steppers.categoryStepper ?? steppers.declinableStepper;

        if (!currentStepper.isValid || currentStepper.canMakeMoreChoices) {
          return;
        }

        if (currentStepper.hasNextStep) {
          const nextStep = currentStepper.nextStep;
          if (nextStep) {
            currentStepper.setSelectedStep(nextStep);
          }
          return;
        }
        const nextStepper = StepperUtil.findStepperWithNextStep(
          this.declinableProductStepperStore.stepper(),
        );
        const nextStep = nextStepper?.step;

        if (!nextStep) {
          return;
        }

        if (nextStep.hasNextStep && nextStep.nextStep) {
          nextStep.setSelectedStep(nextStep.nextStep);
          return;
        }
        return;
      },
      {
        allowSignalWrites: true,
      },
    );
  }

  public initAutoNextStep() {}
}
